{
  "title": "Не вдалося завершити реєстрацію",
  "message": "Ваш ідентифікатор не вдалося підтвердити"
}
